import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-fill text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading text-foreground-100 group-hover:text-primary-400 transition-colors">
              桃子影院
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className={`px-4 py-2 rounded-lg text-sm transition-colors whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.key}`)
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <div className="w-5 h-5 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500">
                <i className="ri-search-line text-sm"></i>
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索剧集..."
                className="w-56 pl-9 pr-4 py-2 bg-background-100 border border-background-300/50 rounded-full text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 focus:ring-1 focus:ring-primary-500/20 transition-all"
              />
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-300 hover:text-foreground-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className={`block px-4 py-3 rounded-lg text-sm transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className={`block px-4 py-3 rounded-lg text-sm transition-colors whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.key}`)
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block px-4 py-3 rounded-lg text-sm transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
            <div className="pt-3 px-4">
              <div className="relative">
                <div className="w-5 h-5 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500">
                  <i className="ri-search-line text-sm"></i>
                </div>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索剧集..."
                  className="w-full pl-9 pr-4 py-2.5 bg-background-100 border border-background-300/50 rounded-full text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-all"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}